<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="middle-panel">
                <div class="dialog-title">
                    <span v-t="'message.item_two_phase_method_setting'"></span>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-body-small">
                    <el-form label-width="300px" class="dialog-form-item">
                        <!-- ##################################### -->
                        <!-- Two Phase Method ON/OFF               -->
                        <!-- ##################################### -->
                        <el-form-item prop="methodType" ref="methodType">
                            <span slot="label" v-t="'message.item_two_phase_method_console'"/>
                            <el-switch
                                v-model="twoPhaseEnable"
                                active-color="#5171cb"
                                @change="handleOptionChange()">
                            </el-switch>
                        </el-form-item>
                    </el-form>
                    <div v-if="twoPhaseEnable">
                        <el-row :gutter="24" class="card-container">
                            <el-col :span="12">
                                <el-card shadow="hover" :class="{'selected-card': input.methodOption === LOGIN_METHOD_MAIL}" @click.native="setMethodOption(LOGIN_METHOD_MAIL)">
                                    <div v-if="methodOption === LOGIN_METHOD_MAIL" class="using-mark" v-t="'message.item_value_used'"></div>
                                    <div class="card-content">
                                        <div v-t="'message.item_value_two_pahse_auth_mail'"></div>
                                        <img src="../../../../assets/icon_email.svg" class="card-icon">
                                    </div>
                                </el-card>
                            </el-col>
                            <el-col :span="12">
                                <el-card shadow="hover" :class="{'selected-card': input.methodOption === LOGIN_METHOD_GA}" @click.native="setMethodOption(LOGIN_METHOD_GA)">
                                    <div v-if="methodOption === LOGIN_METHOD_GA" class="using-mark" v-t="'message.item_value_used'"></div>
                                    <div class="card-content">
                                        <div v-t="'message.item_value_two_pahse_auth_app'"></div>
                                        <img src="../../../../assets/icon_client_setting.svg" class="card-icon">
                                    </div>
                                </el-card>
                            </el-col>
                        </el-row>
                    </div>
                </div>
                <div v-if="input.methodOption === LOGIN_METHOD_MAIL" class="dialog-body-small">
                    <el-form class="dialog-form-item" label-width="170px" @submit.native.prevent>
                        <!--- メールアドレス --->
                        <el-form-item ref="email" prop="email">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_tenant_email'"/> <span class="required" v-t="'message.item_required'"></span>
                                <el-tooltip effect="dark" placement="top-start" >
                                    <div slot="content" style="text-align:left" v-t="'message.hint_notify_email_input'"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-input id="email" size="large" type="text" :placeholder="$t('message.place_holder_input_text')"
                                v-model="input.email.value"
                                @compositionstart.native="compositionStart($event.target.id)"
                                @compositionend.native="compositionEnd($event.target.id)"
                                @input.native="inputCheck($event.target.id)"
                                clearable @clear="setButtonStatus()"/>
                        </el-form-item>
                        <span v-t="'message.info_mail_for_notify_code'"></span>
                    </el-form>
                </div>

                <div v-if="input.methodOption === LOGIN_METHOD_GA" style="padding-bottom: 10px">
                    <span v-t="'message.desc_two_phase_auth_ga_nav'" style="padding-left: 20px;"></span>
                </div>

                <hr class="dialog-hr">
                <div class="dialog-button-field">
                    <el-button class="dialog-cancel-button" type="button" @click="$emit('cancel')" v-t="'message.button_cancel'"></el-button>
                    <el-button
                        class="dialog-ok-button"
                        :disabled="buttonConfig.disabled"
                        @click="buttonConfig.clickHandler"
                        v-t="buttonConfig.textKey">
                    </el-button>
                </div>
            </div>
            <el-dialog :visible.sync="showWarningDialog" width="30%" append-to-body>
                <div v-t="'message.warn_reset_ga_secret_key'" style="color: red;"></div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="handleWarningDialogClose" v-t="'message.button_cancel'"></el-button>
                    <el-button type="primary" @click="handleWarningDialogOk" v-t="'message.button_ok'"></el-button>
                </span>
            </el-dialog>
        </div>
    </transition>
</template>

<script>
import constants from '../../../constants.js';
import commonValidate from '../../../common-validate.js';

export default {
    props: {
        methodOption: Number,
        email: String,
    },
    data() {
        return {
            // CONST
            LOGIN_METHOD_NO_SETTING: constants.LOGIN_METHOD_NO_SETTING,
            LOGIN_METHOD_MAIL: constants.LOGIN_METHOD_MAIL,
            LOGIN_METHOD_GA: constants.LOGIN_METHOD_GA,

            input: {
                methodOption: constants.LOGIN_METHOD_NO_SETTING,
                email: { validationRule: "userEmailAddress", valid: true, value: null, isComposing: false }
            },
            twoPhaseEnable: false,
            disabled: true,
            showWarningDialog: false,
        };
    },
    methods: {
        inputCheck(eventTargetId) {
            if (this.input[eventTargetId].isComposing) {
                // inputting with IME
                return;
            }
            let validateResult;
            validateResult = commonValidate.validateItem(this.$i18n, this.input[eventTargetId].validationRule, this.input[eventTargetId].value);
            if (validateResult.valid) {
                this.input[eventTargetId].valid = true;
                this.$refs[eventTargetId].clearValidate();
            } else {
                this.input[eventTargetId].valid = false;
                this.$refs[eventTargetId].validateState = "error";
                this.$refs[eventTargetId].validateMessage = validateResult.message;
            }
            this.setButtonStatus();
        },
        compositionStart(eventTargetId) {
            this.input[eventTargetId].isComposing = true;
        },
        compositionEnd(eventTargetId) {
            this.input[eventTargetId].isComposing = false;
            this.inputCheck(eventTargetId);
        },
        setButtonStatus() {
            if (this.input.methodOption === constants.LOGIN_METHOD_MAIL) {
                if (!this.input.email.value || !this.input.email.valid) {
                    this.disabled = true;
                    return;
                }

                if (this.input.email.value !== this.email) {
                    this.disabled = false;
                    return; 
                }
            }
    
            this.disabled = (this.input.methodOption === this.methodOption);
        },
        goVerifyPage() {
            this.$emit('next', this.input);
        },
        save() {
            const request = {
                methodOption: constants.LOGIN_METHOD_NO_SETTING,
            }
            this.$emit('save', request);
        },
        handleOptionChange: function() {
            if (!this.twoPhaseEnable) {
                this.input.methodOption = constants.LOGIN_METHOD_NO_SETTING;
            }
            this.disabled = this.twoPhaseEnable && this.input.methodOption === constants.LOGIN_METHOD_NO_SETTING
                            ? true 
                            : (this.input.methodOption === this.methodOption);
        },
        setMethodOption(value) {
            this.input.methodOption = value;
            this.setButtonStatus();
        },
        showDetail(event) {
            event.stopPropagation();
            this.$emit('showDetail');
        },
        displayWarningDialog() {
            this.showWarningDialog = true;
        },
        handleWarningDialogOk() {
            if (this.twoPhaseEnable) {
                this.goVerifyPage();
            } else {
                this.save();
            }
            this.showWarningDialog = false;
        },
        handleWarningDialogClose() {
            this.showWarningDialog = false;
        },
    },
    mounted() {
        this.twoPhaseEnable = false;
        if (this.methodOption === constants.LOGIN_METHOD_MAIL) {
            this.twoPhaseEnable = true;
            this.input.email.valid = true;
        }
        if (this.methodOption === constants.LOGIN_METHOD_GA) {
            this.twoPhaseEnable = true;
        }
        this.input.email.value = this.email;
        this.input.methodOption = this.methodOption;
    },
    computed: {
        applyTag() {
            return 'using-mark';
        },
        buttonConfig() {
            let config = {
                disabled: true,
                clickHandler: () => {},
                textKey: 'message.button_save',
            };

            // disabled
            if (this.methodOption === constants.LOGIN_METHOD_GA && this.input.methodOption === constants.LOGIN_METHOD_GA) {
                config.disabled = false;
            } else {
                config.disabled = this.disabled;
            }
            // clickHandler,text
            if (this.twoPhaseEnable) {
                config.clickHandler = this.methodOption === constants.LOGIN_METHOD_GA ? this.displayWarningDialog : this.goVerifyPage;
                config.textKey = this.methodOption === constants.LOGIN_METHOD_GA && this.input.methodOption === constants.LOGIN_METHOD_GA
                    ? 'message.button_recertify'
                    : 'message.button_verify';
            } else if (this.methodOption === constants.LOGIN_METHOD_GA) {
                config.clickHandler = this.displayWarningDialog;
            } else {
                config.clickHandler = this.save;
            }
            return config;
        }
    }
}
</script>

<style scoped>
button.input-pass-check {
    border-style: none;
    background-color: #fff;
    cursor: pointer;
    outline: none;
    position: absolute;
    height: 20px;
    width: 44px;
    left: 305px;
    top: 2px;
    z-index: 10;
    color: #848991;
    font-size: 10px;
}

.middle-panel {
    background: #fff;
    position: absolute;
    padding: 0;
    left: 50%;
    top: 50%;
    width: 580px;
    max-height: 80vh;
    margin-top: -40vh;
    margin-left: -250px;
    transition: all .3s ease;
    border-radius: 4px;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    overflow: hidden;
}

.el-row {
    display: flex;
}

.el-col {
    display: flex;
    flex-direction: column;
}

.card-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.el-card {
    position: relative;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.card-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    height: 100%;
}

.card-icon {
    width: 30%;
    height: 30%;
    margin-top: 10px;
}

.using-mark {
    position: absolute;
    top: 10px;
    right: 10px;
    background-color: #5171cb;
    color: white;
    padding: 2px 10px;
    border-radius: 5px;
    font-size: 0.8em;
}

.selected-card {
    border: 2px solid #5171cb;
    box-shadow: 0 4px 8px 0 rgba(81, 113, 203, 0.5);
}

.dialog-form-item {
    overflow: hidden;
}

.dialog-body-small {
    overflow: hidden;
}
</style>
